/** @jsx jsx */
import { FC, RefObject } from "react";
import { jsx } from "theme-ui";

import { JobApplicationStep } from "@/data/job-applications/types/JobApplicationStep";
import { JobRequest } from "@/data/job-requests/types/JobRequest";
import { ApplyWizardFiles } from "@/views/job-applications/apply/_files/ApplyWizardFiles";

import { ApplyWizardCandidate } from "../_candidate/ApplyWizardCandidate";
import { ApplyWizardDetails } from "../_details/ApplyWizardDetails";
import { ApplyWizardQuestionnaire } from "../_questionnaire/ApplyWizardQuestionnaire";
import { ApplyWizardSummary } from "../_summary/ApplyWizardSummary";
import { ApplyWizardWorkstyles } from "../_workstyles/ApplyWizardWorkstyles";
import { useApplyWizard } from "./ApplyWizardContext";

interface ApplyWizardContentProps {
  jobRequest: JobRequest;
  modalRef: RefObject<HTMLDivElement>;
}

export const ApplyWizardContent: FC<ApplyWizardContentProps> = ({ jobRequest, modalRef }) => {
  const { currentStep } = useApplyWizard();

  switch (currentStep) {
    case JobApplicationStep.CANDIDATE:
      return <ApplyWizardCandidate jobRequest={jobRequest} />;
    case JobApplicationStep.DETAILS:
      return <ApplyWizardDetails jobRequest={jobRequest} />;
    case JobApplicationStep.FILES:
      return <ApplyWizardFiles />;
    case JobApplicationStep.QUESTIONNAIRE:
      return <ApplyWizardQuestionnaire jobRequest={jobRequest} />;
    case JobApplicationStep.WORKSTYLES:
      return <ApplyWizardWorkstyles />;
    case JobApplicationStep.SUMMARY:
      return <ApplyWizardSummary jobRequest={jobRequest} modalRef={modalRef} />;
    default:
      return null;
  }
};
